var exports = {
  "Qs": "CustomStatusDisplay.module__content___ZlZsUm",
  "pF": "CustomStatusDisplay.module__singleLine___ZlZsUm",
  "tD": "CustomStatusDisplay.module__constrained___ZlZsUm",
  "IY": "CustomStatusDisplay.module__truncatedText___ZlZsUm",
  "j9": "CustomStatusDisplay.module__clamped___ZlZsUm",
  "H0": "CustomStatusDisplay.module__statusEmoji___ZlZsUm",
  "My": "CustomStatusDisplay.module__statusEmojiWrapper___ZlZsUm",
  "hb": "CustomStatusDisplay.module__staticEmoji___ZlZsUm",
  "oG": "CustomStatusDisplay.module__animatedEmoji___ZlZsUm",
  "kK": "CustomStatusDisplay.module__hiddenVisually___ZlZsUm",
  "SA": "CustomStatusDisplay.module__jumbo___ZlZsUm",
  "We": "CustomStatusDisplay.module__editableWrapper___ZlZsUm",
  "Ke": "CustomStatusDisplay.module__editableTextHover___ZlZsUm",
  "BW": "CustomStatusDisplay.module__editPencilIcon___ZlZsUm",
  "dX": "CustomStatusDisplay.module__editableEmojiOnly___ZlZsUm",
  "qf": "CustomStatusDisplay.module__placeholder___ZlZsUm",
  "Dm": "CustomStatusDisplay.module__placeholderIcon___ZlZsUm",
  "RC": "CustomStatusDisplay.module__placeholderText___ZlZsUm",
  "_C": "CustomStatusDisplay.module__emojiPressable___ZlZsUm",
  "on": "CustomStatusDisplay.module__emojiTooltipTrigger___ZlZsUm",
};

module.exports = exports;
